import { render, staticRenderFns } from "./trouble-helper.vue?vue&type=template&id=51828402&scoped=true&"
import script from "./trouble-helper.vue?vue&type=script&lang=js&"
export * from "./trouble-helper.vue?vue&type=script&lang=js&"
import style0 from "./trouble-helper.vue?vue&type=style&index=0&id=51828402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51828402",
  null
  
)

export default component.exports